// extracted by mini-css-extract-plugin
export default {"payment":"CampaignPaymentTile_payment__nHbQk","timeStamp":"CampaignPaymentTile_timeStamp__R1Hyz","manualPaymentText":"CampaignPaymentTile_manualPaymentText__jZ7C0"};